import { render, staticRenderFns } from "./loading.block.pug?vue&type=template&id=c8af6930&scoped=true&lang=pug&external"
import script from "./loading.block.ts?vue&type=script&lang=ts&external"
export * from "./loading.block.ts?vue&type=script&lang=ts&external"
import style0 from "./loading.block.sass?vue&type=style&index=0&id=c8af6930&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8af6930",
  null
  
)

export default component.exports